function parseDateValue(value) {
  if (!value) return null
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  const str = String(value).trim()
  // Date-only fields (e.g. event_date) — not ISO datetimes from the API.
  const dateOnly = str.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (dateOnly) {
    return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
  }

  const parsed = new Date(str)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

function pad2(value) {
  return String(value).padStart(2, '0')
}

/** Display date as DD/MM/YYYY across the site. */
export function formatDate(value) {
  const date = parseDateValue(value)
  if (!date) return ''

  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`
}

/** Display datetime as DD/MM/YYYY HH:mm. */
export function formatDateTime(value) {
  const date = parseDateValue(value)
  if (!date) return ''

  return `${formatDate(date)} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`
}
